<template>
  <div class="flex items-center justify-center">
    <div class="mr-2">
      <svg class="w-5 h-5 text-(--brand-primary)" xmlns="http://www.w3.org/2000/svg"
           fill="currentColor" stroke="currentColor" stroke-width="0"
           viewBox="0 0 512 512">
        <path stroke="none"
              d="m479.07 111.36-.79-12.53-12.36-2.21c-86.5-15.52-122.61-26.74-203.33-63.2l-6.59-3-6.59 3C168.69 69.88 132.58 81.1 46.08 96.62l-12.36 2.21-.79 12.53c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 0 0 129 393.11c53.47 56.73 110.24 81.37 121.07 85.73l6 2.41 6-2.41c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0 0 71.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-252.91 216L153.37 256l22.4-22.86 48.47 47.49 110.13-127.2 24.2 20.94z"/>
      </svg>
    </div>
    <p class="text-gray-700 font-medium">Your details are secure</p>
  </div>
</template>
